const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/contact-card', {
  title: 'Card de Fale Conosco',
  description: 'Item que compõe a sessão Fale Conosco',
  icon: 'admin-comments',
  category: 'layout',
  attributes,
  parent: ['app/contact-us'],
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
